import React from 'react';
import { IconProps } from '.';

const SvgNumFiveFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill={secondaryColor}
        d='M12.026 16.575c2.122 0 3.568-1.361 3.568-3.269 0-1.81-1.29-3.105-3.021-3.099-.827-.006-1.543.332-1.888.795h-.078l.26-2.383h4.193V7.017H9.253l-.508 5.43h1.77c.28-.527.775-.794 1.485-.794.99.006 1.7.703 1.693 1.705.006.984-.69 1.674-1.667 1.667-.82.007-1.49-.501-1.537-1.237h-1.9c.032 1.628 1.47 2.787 3.437 2.787Z'
      />
    </svg>
  );
};

export default SvgNumFiveFill;
